import styled from '@emotion/styled'
import { PAPER_HEIGHTS } from '../../theme'

export const VideoCover = styled('div')({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: PAPER_HEIGHTS.highest,
})
